import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './mail_template.route';

import MailTextService from '../../components/api/mail_text/mail_text.service';

export class MailTemplateController {
    /*@ngInject*/
    constructor($mdDialog, MailTextService) {
        this.MailTextService = MailTextService;
        this.$mdDialog = $mdDialog;

        this.successDialog = $mdDialog.alert({
            clickOutsideToClose: true,
            title: '保存しました',
            ok: 'OK'
        });
    }

    $onInit() {
        this.MailTextService.oem_api.index(response => {
            this.template = response;
        });
    }

    submit(template) {
        this.MailTextService.oem_api.create(template, response => {
            this.template.mail_header = response.mail_header;
            this.template.mail_footer = response.mail_footer;
            this.$mdDialog.show(this.successDialog);
        });
    }

    onChange(propName) {
        //RFC2822 2.1.1 より 78 文字以上の行は強制的に改行する
        this.template[propName] = this.breakLongLine(this.template[propName]);
    }

    breakLongLine(text) {
        let lines = text.split('\n');
        return lines.map(line => {
            return (line.length <= 78) ? line : this.breakLongLine(this.textInsert(line, 78, '\n'));
        }).join('\n');
    }

    textInsert(base, index, text) {
        return base.slice(0, index) + text + base.slice(index, base.length);
    }
}

export default angular.module('leptonApp.mailTemplate', [uiRouter, MailTextService])
    .config(routing)
    .component('mailTemplate', {
        template: require('./mail_template.html'),
        controller: MailTemplateController
    })
    .name;



// WEBPACK FOOTER //
// ./public/dev/app/mail_template/mail_template.component.js